var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.profileImage)?_c('div',{staticClass:"profile-image pr-2"},[_c('v-badge',{attrs:{"bordered":"","bottom":"","color":'error',"offset-x":"13","offset-y":"13","dot":""}},[_c('v-avatar',{attrs:{"width":_vm.size}},[_c('v-img',{attrs:{"src":_vm.profileImage}})],1)],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }